var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio',{attrs:{"label":_vm.item.label,"value":_vm.index,"disabled":_vm.disabled || _vm.item.readonly},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }